import { Card, CardContent, Typography, Box, useTheme } from '@mui/material'
import useCustomStyles from '../../../hooks/CustomStylesHook'
import Colors from '../../../utils/colors.json'

const styles = (theme: any) => ({
  card: {
    backgroundColor: theme.palette.primary.light,
    borderRadius: '20px',
    padding: theme.spacing(2),
  },
  progressBarContainer: {
    position: 'relative',
    height: '20px',
    borderRadius: '10px',
    backgroundColor: '#e0e0e0',
    overflow: 'hidden',
  },
  progressBar: {
    height: '100%',
    backgroundColor: '#4caf50',
    transition: 'width 0.3s ease',
  },
  detailsContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: theme.spacing(1),
  },
  detailLabel: {
    fontSize: '14px',
    color: '#757575',
  },
  detailValue: {
    fontSize: '16px',
    fontWeight: 'bold',
  },
})

const ClaimProgressCard = () => {
  const theme = useTheme()
  const classes = useCustomStyles(styles, theme)
  const claimedAmount = 8000
  const remainingCoverage = 200000
  const totalCoverage = claimedAmount + remainingCoverage
  const claimedPercentage = (claimedAmount / totalCoverage) * 100

  return (
    <Card className={classes?.card} elevation={0}>
      <CardContent>
        <Typography
          variant='h6'
          color={Colors.TEXT_COLOR_SECONDARY}
          gutterBottom
        >
          Claims
        </Typography>
        <Box className={classes?.progressBarContainer}>
          <Box
            className={classes?.progressBar}
            style={{ width: `${claimedPercentage}%` }}
          />
        </Box>
        <Box className={classes?.detailsContainer}>
          <Box>
            <Typography className={classes?.detailLabel}>
              You Have Claimed
            </Typography>
            <Typography className={classes?.detailValue}>
              ₹ {claimedAmount.toLocaleString()}
            </Typography>
          </Box>
          <Box>
            <Typography className={classes?.detailLabel}>
              Remaining Coverage
            </Typography>
            <Typography className={classes?.detailValue}>
              ₹ {remainingCoverage.toLocaleString()}
            </Typography>
          </Box>
        </Box>
      </CardContent>
    </Card>
  )
}

export default ClaimProgressCard
